import { useMemo } from 'react'
import { useResponsiveColumns } from './useResponsiveColumns'

interface ResponsiveColumnsConfig {
  mobile: string[]
  tablet: string[]
  desktop: string[]
  desktopLarge?: string[]
}

interface ResponsiveColumnsOptions {
  sidebarExpanded?: boolean
  excludeColumns?: string[]
  customBreakpoints?: {
    large?: string
    veryLarge?: string
  }
}

interface ExpandedRowConfig {
  component: React.ComponentType<any>
  shouldRender: (screenSize: 'mobile' | 'tablet' | 'desktop') => boolean
  fields: any[]
}

interface Column {
  name: string
  priority?: number
  [key: string]: any
}

export const useResponsiveTable = (
  responsiveConfig: ResponsiveColumnsConfig,
  allColumns: Column[],
  options: ResponsiveColumnsOptions = {},
  expandedRowConfig?: ExpandedRowConfig
) => {
  const { screenSize, visibleColumns, getVisibleColumns } = useResponsiveColumns(
    responsiveConfig,
    options
  )

  const filteredColumns = useMemo(() => {
    return allColumns.filter(({ name }) => visibleColumns.includes(name))
  }, [allColumns, visibleColumns])

  const responsiveTableConfig = useMemo(() => {
    if (!expandedRowConfig) return undefined

    return {
      expandedRowRenderer: {
        component: expandedRowConfig.component,
        shouldRender: expandedRowConfig.shouldRender,
        getVisibleColumns
      }
    }
  }, [expandedRowConfig, getVisibleColumns])

  return {
    screenSize,
    visibleColumns,
    filteredColumns,
    responsiveConfig: responsiveTableConfig,
    getVisibleColumns
  }
}
